<ng-container *ngIf="alerts$ | async as alerts">
  <div *ngIf="alerts.length" class="alert-stack">
    <app-alert-banner
      *ngFor="let alert of alerts; trackBy: trackByAlertId"
      [alert]="alert"
      (dismiss)="dismiss($event)">
    </app-alert-banner>
  </div>
</ng-container>
